/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlinePresenceSettings {
    angular.module("meevo.plugins.onlinePresenceSettings", []);
}